import { render, staticRenderFns } from "./SrHeadline.vue?vue&type=template&id=12815354"
import script from "./SrHeadline.vue?vue&type=script&lang=js"
export * from "./SrHeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports